import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IUser } from "../models/user.model";
import { ActivatedRoute, Router } from "@angular/router";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { UserInfoService } from "../services/user-info.service";
import { ZpDataService } from "../services/zp-data.service";
import { NotificationService } from "../services/notification.service";
import { ZPNotification } from "../models/zpnotification";
import { CustomValidators } from "../custom-validators";
import { ThemeService } from "../theme/theme-service.service";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.scss"],
})
export class ResetPasswordComponent implements OnInit {
  public parentForm: FormGroup;
  public submitted = false;
  public myUser: IUser;
  public activationCode: string;
  public confirmPasswordValidator: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private userInfoService: UserInfoService,
    private ZpDataService: ZpDataService,
    private notifier: NotificationService,
    public themeService: ThemeService
  ) { }

  ngOnInit() {
    this.parentForm = this.formBuilder.group({
      password: [
        "",
        Validators.compose([
          Validators.required,
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true,
          }),
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true,
          }),
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true,
          }),
          Validators.minLength(8),
        ]),
      ],
      confirmPassword: ["", [Validators.required]],
    });
    this.sideNavBarVisibilityService.hideSideNav = true;

    this.activationCode = this.route.snapshot.paramMap.get("activationCode");

    if (!this.activationCode) {
      alert(
        "Please follow the link sent to your email to reset your password. Otherwise please contact support."
      );
      this.goto("log-in");
    }
  }

  get f() {
    return this.parentForm.controls;
  }

  async onSubmit() {
    // await this.getMyUser();
    this.submitted = true;

    if (this.parentForm.invalid) {
      return;
    } else {
      let password = this.parentForm.value.password;
      let confirmPassword = this.parentForm.value.confirmPassword;
      if (password == confirmPassword) {
        let res = await this.ZpDataService.passwordReset(
          this.activationCode,
          password,
          confirmPassword
        );
        this.confirmPasswordValidator = true;
        if (res.success) {
          this.notifier.changeMessage(
            new ZPNotification("Password successfully reset. Please log in.")
          );
          this.router.navigateByUrl("/log-in");
        } else {
          alert(res.message);
        }
      } else {
        this.confirmPasswordValidator = false;
      }
    }
    // if (this.SignInPassWordCompletedForm != this.myUser.email) {
    //   this.submitted = false;
    //   return;
    // }
    //this.goto('reset-password-completed/'+id);
  }

  goto(url: string) {
    this.submitted = false;
    this.router.navigate(["/" + url]);
  }

  onReset() {
    this.submitted = false;
    this.parentForm.reset();
  }

  // async getMyUser() {
  //   if (!this.myUser) {
  //     await this.ZpDataService.getUser();
  //   }
  // }
}
